module.exports = __webpack_public_path__ + "img/view-circle.f5b6c8a7.svg";